import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MapResults.css';
import cx from 'classnames';

// Redux
import { connect } from 'react-redux';

// Redux form
import { formValueSelector, change, submit } from 'redux-form';

// Google Places Map Component
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';

// Assets
import mapPinIcon from './map-pin-ornage.png';
import mapPinIcon2 from './map-pin-blue-dark.png';
import mapPinIcon3 from './map-pin3.png';

// Component
import MapListingItem from '../MapListingItem';
import RedoSearch from '../RedoSearch';

// Actions
import { setPersonalizedValues } from '../../../actions/personalized';
import { Address } from 'glamorous';
import { getp } from '../../../helpers/getProp';

const refs = {};

const GoogleMapPlace = withGoogleMap(props => (
  <GoogleMap
    defaultZoom={14}
    ref={map => {
      props.handleFitBounds(map);
      refs.map = map;
    }}
    center={props.center}
    onClick={props.onMapClick}
    onDragStart={props.handleOnDragStart}
    onDragEnd={props.handleOnDragEnd}
    onZoomChanged={props.onZoomChanged}
    onMouseOver={props.onMouseOver}
    onMouseOut={props.onMouseOut}
    onCenterChanged={e => props.onCenterChanged(e)}
    defaultOptions={{
      maxZoom: 16,
      backgroundColor: '',
      streetViewControl: false,
      zoomControlOptions: {
        position: props.googleMaps.ControlPosition.LEFT_TOP,
      },
      mapTypeControl: false,
      draggable: true,
      fullscreenControl: false,
    }}
  >
    {props.markers.map((marker, key) => (
      <Marker
        position={marker.position}
        clickable={true}
        icon={{
          url: mapPinIcon,
          scale: 5,
        }}
        key={key}
        onClick={() => props.onMarkerClick(marker)}
      >
        {marker.showInfo && (
          <InfoWindow
            onCloseClick={() => props.onMarkerClose(marker)}
            options={{
              maxWidth: 262,
              closeBoxURL: '',
              closeBoxMargin: '',
              pixelOffset: new props.googleMaps.Size(0, 0),
              disableAutoPan: false,
              infoBoxClearance: new props.googleMaps.Size(1, 1),
              boxStyle: { width: '240px' },
            }}
          >
            <MapListingItem
              id={marker.id}
              basePrice={marker.basePrice}
              currency={'USD'}
              title={marker.title}
              beds={marker.beds}
              personCapacity={marker.personCapacity}
              roomType={marker.roomType}
              coverPhoto={marker.coverPhoto}
              listPhotos={marker.listPhotos}
              bookingType={marker.bookingType}
              reviewsCount={marker.reviewsCount}
              reviewsStarRating={marker.reviewsStarRating}
              wishListStatus={marker.wishListStatus}
              isListOwner={marker.isListOwner}
            />
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
));

class MapResults extends React.Component {
  static propTypes = {
    initialFilter: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      personCapacity: PropTypes.number,
      dates: PropTypes.string,
    }),
    chosenLat: PropTypes.number,
    chosenLng: PropTypes.number,
    total: PropTypes.number,
    results: PropTypes.array,
    personalized: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    change: PropTypes.func,
    submit: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      zoom: 10,
      center: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      bounds: {},
      searchByMapResults: false,
      isMapDrag: false,
      isMapZoom: false,
    };
    this.onMapClick = this.onMapClick.bind(this);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
    this.handleFitBounds = this.handleFitBounds.bind(this);
    this.handleBoundsChanged = this.handleBoundsChanged.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.handleOnDragStart = this.handleOnDragStart.bind(this);
    this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
    this.handleMapTouch = this.handleMapTouch.bind(this);
    this.handleMapUnTouch = this.handleMapUnTouch.bind(this);
  }

  componentDidMount() {
    const {
      results,
      initialFilter,
      searchSettings,
      personalized,
      googleMaps,
    } = this.props;
    const { center } = this.state;
    var bounds = new googleMaps.LatLngBounds();

    if (results && results.length > 0) {
      let positions = [];

      buildResults(results, googleMaps, positions, bounds);
      this.setState({ markers: positions, bounds });
    } else {
      let defaultCordinates;
      if (personalized && personalized.lat && personalized.lng) {
        let centerValue = {
          lat: personalized.lat,
          lng: personalized.lng,
        };
        defaultCordinates = new googleMaps.LatLng(
          centerValue.lat,
          centerValue.lng,
        );
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds, center: centerValue });
      } else if (initialFilter && initialFilter.lat && initialFilter.lng) {
        let centerValue = {
          lat: initialFilter.lat,
          lng: initialFilter.lng,
        };
        defaultCordinates = new googleMaps.LatLng(
          centerValue.lat,
          centerValue.lng,
        );
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds, center: centerValue });
      } else {
        let defaultCordinates = new googleMaps.LatLng(center.lat, center.lng);
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      results,
      personalized,
      initialFilter,
      searchByMapValue,
      googleMaps,
    } = nextProps;
    const { center, searchByMapResults } = this.state;
    var bounds = new googleMaps.LatLngBounds();

    if (
      !this.state.searchByMapResults ||
      (searchByMapValue && this.state.searchByMapResults !== searchByMapValue)
    ) {
      this.setState({
        searchByMapResults: searchByMapValue,
      });
    }

    if (results && results.length > 0) {
      let positions = [];

      buildResults(results, googleMaps, positions, bounds);
      this.setState({
        markers: positions,
        bounds,
      });
    } else {
      let defaultCordinates;
      if (personalized && personalized.lat && personalized.lng) {
        let centerValue = {
          lat: personalized.lat,
          lng: personalized.lng,
        };
        defaultCordinates = new googleMaps.LatLng(
          centerValue.lat,
          centerValue.lng,
        );
        bounds.extend(defaultCordinates);
        this.setState({ markers: [], bounds, center: centerValue });
      } else if (initialFilter && initialFilter.lat && initialFilter.lng) {
        let centerValue = {
          lat: initialFilter.lat,
          lng: initialFilter.lng,
        };
        defaultCordinates = new googleMaps.LatLng(
          centerValue.lat,
          centerValue.lng,
        );
        bounds.extend(defaultCordinates);
        if (!searchByMapResults) {
          this.setState({ markers: [], bounds, center: centerValue });
        }
      } else {
        let defaultCordinates = new googleMaps.LatLng(center.lat, center.lng);
        bounds.extend(defaultCordinates);
        if (!searchByMapResults) {
          this.setState({ markers: [], bounds });
        }
      }
    }
  }

  handleFitBounds(map) {
    const { bounds, markers, searchByMapResults } = this.state;
    const { initialLoad } = this.props;
    if (map != null && bounds != null) {
      //setCenter
      initialLoad ? map.fitBounds(bounds) : true;
    }
  }

  handleBoundsChanged() {
    let center = new this.props.googleMaps.getCenter();
  }

  onMapClick() {
    const { markers } = this.state;
    if (markers.length > 0) {
      this.setState({
        markers: markers.map(marker => {
          return {
            ...marker,
            showInfo: false,
            icon: mapPinIcon2,
          };
          return marker;
        }),
      });
    }
  }

  getCenter(e) {
    let center, lat, lng, northEast, southWest;
    if (refs && refs.map) {
      center = refs.map.getCenter();
      lat = center.lat();
      lng = center.lng();
    }
  }

  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: true,
            icon: mapPinIcon,
          };
        } else {
          return {
            ...marker,
            showInfo: false,
            icon: mapPinIcon,
          };
        }
        return marker;
      }),
      center: {
        lat: targetMarker.lat,
        lng: targetMarker.lng,
      },
      bounds: null,
    });
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false,
            icon: mapPinIcon,
          };
        }
        return marker;
      }),
    });
  }

  async handleOnDragStart() {
    const { change, submit } = this.props;
    this.setState({
      isMapDrag: true,
    });
    await change('SearchForm', 'initialLoad', false);
  }

  async handleMapTouch() {
    const { change, submit } = this.props;
  }

  async handleMapUnTouch() {
    const { change, submit } = this.props;
  }

  async handleZoomChanged() {
    const { change, submit, searchByMapValue } = this.props;
    const { isMapDrag, isMapZoom } = this.state;
    if (refs && refs.map && isMapZoom === false) {
      this.setState({
        isMapZoom: !isMapZoom,
      });
    }

    let center, lat, lng, bounds, northEast, southWest, zoom;
    let new_sw, new_ne, new_bounds;
    if (refs && refs.map && isMapZoom) {
      center = refs.map.getCenter();
      zoom = refs.map.getZoom();
      lat = center.lat();
      lng = center.lng();
      bounds = refs.map.getBounds();
      northEast = bounds.getNorthEast();
      southWest = bounds.getSouthWest();
      new_sw = new this.props.googleMaps.LatLng(
        southWest.lat(),
        southWest.lng(),
      );
      new_ne = new this.props.googleMaps.LatLng(
        northEast.lat(),
        northEast.lng(),
      );
      new_bounds = new this.props.googleMaps.LatLngBounds(new_sw, new_ne);
      // this.setState({
      //   bounds: new_bounds,
      //   searchByMapResults: searchByMapValue,

      // });
      //refs.map.panToBounds(new_bounds);
      //refs.map.fitBounds(bounds);

      await change('SearchForm', 'initialLoad', false);

      if (searchByMapValue) {
        await change('SearchForm', 'lat', lat);
        await change('SearchForm', 'lng', lng);
        await change('SearchForm', 'sw_lat', southWest.lat());
        await change('SearchForm', 'sw_lng', southWest.lng());
        await change('SearchForm', 'ne_lat', northEast.lat());
        await change('SearchForm', 'ne_lng', northEast.lng());
        //await change('SearchForm', 'searchByMap', true);
        await submit('SearchForm');
      }
    }
  }

  async handleOnDragEnd() {
    const {
      change,
      submit,
      searchByMapValue,
      setPersonalizedValues,
    } = this.props;
    const { isMapDrag } = this.state;
    let center, lat, lng, bounds, northEast, southWest;
    let new_sw, new_ne, new_bounds;

    if (refs && refs.map && isMapDrag) {
      center = refs.map.getCenter();
      lat = center.lat();
      lng = center.lng();
      bounds = refs.map.getBounds();
      northEast = bounds.getNorthEast();
      southWest = bounds.getSouthWest();
      new_sw = new this.props.googleMaps.LatLng(
        southWest.lat(),
        southWest.lng(),
      );
      new_ne = new this.props.googleMaps.LatLng(
        northEast.lat(),
        northEast.lng(),
      );
      new_bounds = new this.props.googleMaps.LatLngBounds(new_sw, new_ne);
      // this.setState({
      //   bounds: new_bounds,
      //   searchByMapResults: searchByMapValue,
      //   center
      // });
      //refs.map.panToBounds(new_bounds);
      //refs.map.fitBounds(bounds);

      await change('SearchForm', 'initialLoad', false);
      if (searchByMapValue) {
        await change('SearchForm', 'lat', lat);
        await change('SearchForm', 'lng', lng);

        await setPersonalizedValues({ name: 'lat', value: Number(lat) });
        await setPersonalizedValues({ name: 'lng', value: Number(lng) });

        await change('SearchForm', 'sw_lat', southWest.lat());
        await change('SearchForm', 'sw_lng', southWest.lng());
        await change('SearchForm', 'ne_lat', northEast.lat());
        await change('SearchForm', 'ne_lng', northEast.lng());
        //await change('SearchForm', 'searchByMap', true);
        await submit('SearchForm');
      }
    }
  }

  render() {
    const { center, markers, bounds, zoom } = this.state;
    const { searchByMapValue, googleMaps } = this.props;
    return (
      <div className={cx(s.mapCanvas)}>
        <GoogleMapPlace
          id="map-pane"
          containerElement={<div style={{ width: '100%', height: '100%' }} />}
          mapElement={<div style={{ width: '100%', height: '100%' }} />}
          center={center}
          markers={markers}
          onMapClick={this.onMapClick}
          onMarkerClick={this.handleMarkerClick}
          onMarkerClose={this.handleMarkerClose}
          handleOnDragStart={this.handleOnDragStart}
          handleOnDragEnd={this.handleOnDragEnd}
          onZoomChanged={this.handleZoomChanged}
          handleFitBounds={this.handleFitBounds}
          handleBoundsChanged={this.handleBoundsChanged}
          onCenterChanged={this.getCenter}
          onMouseOver={this.handleMapTouch}
          onMouseOut={this.handleMapUnTouch}
          googleMaps={googleMaps}
        />
        <div className={cx('hidden-xs hidden-sm')}>
          <RedoSearch />
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('SearchForm');

const mapState = state => ({
  results: state.search.data,
  total: state.search.count,
  personalized: state.personalized,
  searchByMapValue: selector(state, 'searchByMap'),
  initialLoad: selector(state, 'initialLoad'),
  //chosenLat: selector(state, 'lat'),
  //chosenLng: selector(state, 'lng'),
});

const mapDispatch = {
  change,
  submit,
  setPersonalizedValues,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(MapResults),
);

function buildResults(results, googleMaps, positions, bounds) {
  results.forEach(item => {
    // console.log('RESULTS item', item);
    // const listPhotos = item.listPhotos;
    // let coverPhoto;
    // if (listPhotos && listPhotos.length > 1) {
    //   coverPhoto = getp(
    //     listPhotos.filter((x, y) => x.id === item.coverPhoto),
    //     '0.name',
    //   );
    // }

    item.listingAddresses &&
      item.listingAddresses.forEach(addr => {
        let data = {};
        const lat = +addr.lat;
        const lng = +addr.lng;
        (data['lat'] = lat),
          (data['lng'] = lng),
          (data['position'] = new googleMaps.LatLng(lat, lng));
        data['id'] = item.id;
        data['basePrice'] = item.basePrice;
        data['title'] = item.title;
        data['roomType'] = item.category;

        data['coverPhoto'] = item.coverPhoto;
        data['listPhotos'] = item.listPhotos;
        data['reviewsCount'] = item.reviewsCount;
        data['reviewsStarRating'] = item.reviewsStarRating;
        data['isListOwner'] = item.isListOwner;
        positions.push(data);
        bounds.extend(new googleMaps.LatLng(lat, lng));
      });
  });
}



// WEBPACK FOOTER //
// ./src/components/SearchListing/MapResults/MapResults.js